import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent {
@Input() text: string = '' ;
@Input() size: string = '';
@Input() round: boolean = true;
randomBgColor: string = '';
isMediumScreen: boolean = false;
ngOnInit() {
  this.setRandomBgColor();
  this.checkScreenSize();
}
@HostListener('window:resize', ['$event'])
onResize() {
  this.checkScreenSize();
}
checkScreenSize() {
  this.isMediumScreen = window.innerWidth <= 768; // Adjust this value to match your medium breakpoint
}
setRandomBgColor() {
  this.randomBgColor = this.getRandomPastelColor();
}
getRandomPastelColor(): string {
  const pastelColors = [
    // '#FFB3BA', // Soft pink
    '#FFDFBA', // Soft peach
    '#BAE1FF', // Soft blue
    // '#E2BAFF', // Soft lavender
    '#F7C8E0', // Soft blush pink
    '#C8F7E4', // Soft aqua
    '#C8DFF7', // Soft sky blue
    '#F7E2C8', // Soft beige
  ];

  const randomIndex = Math.floor(Math.random() * pastelColors.length);
  return pastelColors[randomIndex];
}
getInitials(input: string): string {
  if (!input) return '';
  const initials = input
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word[0].toUpperCase())
    .join('');
  return initials.slice(0, 2);
}
}
